import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

import { AuthenticationService } from './authentication.service';
import {ClientRequest} from  '../../ClientRequest';


@Injectable()
export class CourseService {
    constructor(private clientRequest: ClientRequest) {}
    find(id, params=null): Observable<any> {

        return this.clientRequest.get('/courses/' + id+ (params!=null ? '?params='+params : '')).map((response: HttpResponse<any>) => {
                return response;
            });
    };
    
    getCourses(total): Observable<any> {
        return this.clientRequest.get('/courses?total='+total).map((response: HttpResponse<any>) => {
           return response;
        });
    };
    getMyCourses(): Observable<any> {
        return this.clientRequest.get('/my-course').map((response: HttpResponse<any>) => {
           return response;
        });
    };
    searchCourse(data): Observable<any> {
        data.total = 10;
        return this.clientRequest.get('/courses/search', data).map((response: HttpResponse<any>) => {
           return response;
        });
    };
    getRelateCourse(id, type):Observable<any> {
        return this.clientRequest.get('/courses/relate/'+id+'?type='+type).map((response: HttpResponse<any>) => {
           return response;
        });
    };
    submitComment(model):Observable<any> {
        return this.clientRequest.post('/courses/comment/'+model.id, model).map((response: HttpResponse<any>) => {
           return response;
        });
    };
    getComment(id,page=1): Observable<any> {
        return this.clientRequest.get('/courses/comment/'+id+'?page='+page).map((response: HttpResponse<any>) => {
           return response;
        });
    };
    
}